import React from "react";
import DateHelper from "../../DateHelper/DateHelper";

class SeasonTypeDataType extends React.Component{
  
  constructor(props) {
    super(props);
  }

  render() {
    var date_format = DateHelper.rubyToDateFNS(this.props.date_format);

    if (this.props.row.season_type == 'exact_dates') {
      if(this.props.row.exact_start_date && this.props.row.exact_end_date) {
        return (
          <div>
            {DateHelper.printDateToScreen(DateHelper.server(DateHelper.parseDateFromBackend(this.props.row.exact_start_date)), date_format)} &ndash; {DateHelper.printDateToScreen(DateHelper.server(DateHelper.parseDateFromBackend(this.props.row.exact_end_date)), date_format)}
          </div>
        );
      } else {
        return <div><em>{I18n.t('none')}</em></div>
      }
    } else if (this.props.row.season_type == 'holiday') {
      return (
        <div>
          {this.props.row.holiday_region} &ndash; {this.props.row.holiday_name} &ndash; {this.props.row.holiday_date ? DateHelper.printDateToScreen(DateHelper.server(DateHelper.parseDateFromBackend(this.props.row.holiday_date)), date_format) : I18n.t('na')}
          <br />
          {this.props.row.holiday_days_before} {I18n.t('days_before')} &ndash; {this.props.row.holiday_days_after} {I18n.t('days_after')}
        </div>
      );
    } else {
      return null;
    }
  }

};

export default SeasonTypeDataType